import React from "react";
import "./Footer.css";

const Footer = () => (
  <div className="footer-wrapper">
    <div>
      <a className="footer-link" href="https://www.morganprojects.co.nz">
        <u>BACK TO WEBSITE</u>
      </a>
    </div>
    <div
      style={{
        display: "flex",
        flex: "1 1 auto",
        alignItems: "center",
        flexDirection: "column"
      }}
    >
      <span>Offices in Auckland, Christchurch, Melbourne and Brisbane </span>
      <span>(03) 348 8306 - NZ: 0800 MORGAN - Int: +64 </span>
    </div>
    {/* <div>
      <a
        className="footer-link"
        href="https://www.morganprojects.co.nz/contact-us/"
      >
        <u>CONTACT US</u>
      </a>
    </div> */}
  </div>
);

export default Footer;
